import { el } from './dom.js';

/* --------------------------------------------------------------------------
   Helskärm

   Tabellerna är breda, och på en bärbar dator hjälper det att kunna fälla ut
   verktyget över hela skärmen. Knappen visas bara där helskärm faktiskt går:
   Safari på iPhone stöder det inte för annat än video, och där döljs den.
   -------------------------------------------------------------------------- */

export function fullscreenElement(){
  return document.fullscreenElement || document.webkitFullscreenElement || null;
}

export function fullscreenSupported(){
  const root = document.documentElement;
  const enabled = document.fullscreenEnabled ?? document.webkitFullscreenEnabled;
  return !!enabled && !!(root.requestFullscreen || root.webkitRequestFullscreen);
}

export async function toggleFullscreen(){
  const root = document.documentElement;
  try{
    if(fullscreenElement()){
      await (document.exitFullscreen ? document.exitFullscreen() : document.webkitExitFullscreen());
    }else{
      await (root.requestFullscreen ? root.requestFullscreen() : root.webkitRequestFullscreen());
    }
  }catch{
    // Nekas begäran döljs knappen hellre än att den står kvar och inte gör något
    setupViewButtons(true);
  }
}

export function syncFullscreenLabel(){
  const on = !!fullscreenElement();
  el('btnFullscreenText').textContent = on ? 'Avsluta helskärm' : 'Helskärm';
  el('btnFullscreen').setAttribute('aria-pressed', String(on));
  // Klassen styr både sidhuvudets utseende och vilken ikon som visas
  document.body.classList.toggle('is-fullscreen', on);
}

/**
 * Flyttar helskärmsknappen: i sidhuvudet på uppladdningsskärmen, i raden med
 * Återställ urval och Byt fil när en fil är inläst. Samma knapp, så att
 * texten, ikonen och händelserna följer med.
 */
export function placeViewButton(inAnalysis){
  const host = inAnalysis ? el('activeViewSlot') : el('viewbar');
  const btn = el('btnFullscreen');
  if(btn.parentElement !== host) host.appendChild(btn);
}

/** Visar helskärmsknappen när webbläsaren klarar det. forceOff döljer den. */
export function setupViewButtons(forceOff){
  el('btnFullscreen').hidden = !!forceOff || !fullscreenSupported();
}
